import { GeographicRegion } from "../../../api/calendarEvent";
import DSAutocomplete from "../../system-design/DSAutocomplete";
import DSCircularProgress from "../../system-design/DSCircularProgress";
import DSListItem from "../../system-design/DSListItem";
import DSTextField from "../../system-design/DSTextField";
import useCountryDropdown from "../hooks/useCountryDropdown";

export type CountryDropdownProps = {
  initialCountry: GeographicRegion | null;
  onSelect: (country: GeographicRegion | null) => void;
};

const CountryDropdown = ({
  initialCountry,
  onSelect,
}: CountryDropdownProps) => {
  const {
    options,
    handleInputChange,
    isLoading,
    selectedCountry,
    handleOptionSelect,
  } = useCountryDropdown({ initialCountry, onSelect });

  return (
    <DSAutocomplete
      options={options}
      value={selectedCountry}
      onChange={handleOptionSelect}
      onInputChange={handleInputChange}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <DSListItem {...props} key={option.code}>
          {option.name}
        </DSListItem>
      )}
      renderInput={(params) => (
        <DSTextField
          {...params}
          fullWidth
          label="Country"
          placeholder="Select a country..."
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <DSCircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default CountryDropdown;
